module.exports = __webpack_public_path__ + "img/mississauga-logo.4c2fcd52.png";